const getPaymentDeatilsRequestInsitution = "estraiDettagliPagamentoRichiestaEnte";

export const getPaymentDeatilsRequestInsitutionFunc = [
  "",
  `query ${getPaymentDeatilsRequestInsitution}($idRichiestaServizioEnte: Int!){
    ${getPaymentDeatilsRequestInsitution}(idRichiestaServizioEnte: $idRichiestaServizioEnte)
  }`,
  getPaymentDeatilsRequestInsitution,
];
